export const CmsSchemaData = (function () {
  const selectors = {
    authors: "#authors",
    author: ".author",
    cmsContentWrapper: "#cms-content",
  };

  const init = function () {
    _collectData();
  };

  const _collectData = function () {
    const cmsData = document.querySelector(selectors.cmsContentWrapper);

    if (cmsData) {
      const date = new Date();
      const imageList = [];
      const authorsList = [];

      const title = cmsData.querySelector("h1");

      // Get all images from page
      const images = cmsData.querySelectorAll("img");
      if (images) {
        images.forEach((image) => {
          imageList.push(image.getAttribute("src"));
        });
      }

      // Get all authors from page
      const authorsWrapper = document.querySelector(selectors.authors);
      if (authorsWrapper) {
        const authors = authorsWrapper.querySelectorAll(selectors.author);

        authors.forEach((author) => {
          authorsList.push({
            "@type": "Person",
            name: author.dataset.authorName,
            url: author.dataset.authorUrl ? author.dataset.authorUrl : "",
          });
        });
      }

      const schemaData = {
        "@context": "https://schema.org",
        "@type": "BlogPosting",
        headline: title ? title.innerHTML : "",
        image: imageList,
        datePublished: cmsData.dataset.created
          ? cmsData.dataset.created
          : date.toISOString(),
        dateModified: cmsData.dataset.updated
          ? cmsData.dataset.updated
          : date.toISOString(),
        author: authorsList,
      };

      Schema.add("article", schemaData);
      Schema.render("article");
    }
  };

  return {
    init: init,
  };
})();
